<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-alert v-if="isUnregistTeam" color="cyan" icon="info" value="true">
        「チームを作る」からチームを登録して、大会にエントリーしましょう。
      </v-alert>
      <v-flex xs12 md44 class="my-3">
        <div class="text-xs-center">
          <v-avatar size="60px">
            <img v-if="user" :src="user.photoURL" alt="avatar">
            
          </v-avatar>
          
          <h2 v-if="user" class="headline">{{user.displayName}}</h2>
          <span class="subheading">
          </span>
        </div>
      </v-flex>
  <form>
    <v-text-field
      v-if="user"
      label="E-mail"
      v-model="user.email"
      required
    ></v-text-field>
    <!--
    <v-text-field
      label="ニックネーム"
      v-model="name"
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
    ></v-text-field>
    -->
    <!--
    <v-text-field
      label="生年月日"
      v-model="user.birthday"
    ></v-text-field>

<v-btn block secondary green @click="update">更新する</v-btn>
-->
  </form>
<v-divider></v-divider>


    <v-list two-line>
      <template v-for="item in items">
        <v-subheader v-if="item.header" v-text="item.header" v-bind:key="item.header"></v-subheader>
        <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
        <v-list-tile avatar v-else v-bind:key="item.title" :to="item.to">
          <v-list-tile-avatar>
            <img v-if="item.avatar" v-bind:src="item.avatar">
            <img v-else v-bind:src="defaultTeamAvatar">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="item.title"></v-list-tile-title>
            <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>

    <v-btn class="white--text" color="cyan" v-if="isUnregistTeam" to="/teams/regist">チームを作る</v-btn>

<hr class="divider my-5">

<a v-on:click="logout">ログアウトする</a>

    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'

export default {
  components: {
    firebase
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  data () {
    return {
      defaultTeamAvatar: '/static/defaultteam.png',
      items: [{ header: '所属チーム' }],
      isUnregistTeam: false
    }
  },
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth'
      } else {
        // サインイン済み

        // select teams
        var db = firebase.firestore()
        let query = db.collection('m2m_teams_users').where('user', '==', user.uid) // TODO
                                                    .where('role', '==', 'ADMIN')
        query.get().then(querySnapshot => {
          // this.entrySize = querySnapshot.size
          if (querySnapshot.size === 0) {
            this.isUnregistTeam = true
          }
          querySnapshot.forEach(documentSnapshot => {
            var obj = documentSnapshot.data()
            // team
            var docRef = db.collection('teams').doc(obj.team)
            docRef.get().then(doc => {
              if (doc.exists) {
                this.items.push({ avatar: doc.avatar, title: doc.data().teamName, subtitle: doc.data().teamInfo, to: '/teams/' + doc.id })
              } else {
                console.log('No such document!')
              }
            }).catch(function (error) {
              console.log('Error getting document:', error)
            })
          })
        })
      }
    })
  },
  methods: {
    update: function () {
      var db = firebase.firestore()

      var docRef = db.collection('users').doc(firebase.auth().currentUser.uid)
      docRef.update(this.teamObj).then(() => {
        console.log('Document successfully updated!')
      })
      .catch(function (error) {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error)
      })
    },
    logout: function () {
      firebase.auth().signOut().then(this.onSignOut, this.onError)
      // commit('setUser', null)
    },
    onSignOut: function () {
      console.log('onSignOut')
      this.$router.push({ path: '/' })
    },
    onError: function () {
      console.error('onError')
    }
  }
}
</script>


<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/user/UserProfile.vue